import Abstract from "./Abstract";

export const base_url = "/logs_export";
export const url = process.env.VUE_APP_API_BASE_URL + base_url;
export const abstract = new Abstract(url);

export default class LogsExport {
  static get(params) {
    return abstract.get({ ...params });
  }
}


